<template>
  <SelectSingleInput
    :vid="vid"
    v-model="model"
    :items="itemsComputed"
    item-text="deptText"
    item-value="deptCd"
    :label="labelComputed"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'DepartmentInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0242')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    vid: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label
      },
    },
    itemsComputed: {
      get() {
        return this.items
      },
    },
  },

  async mounted() {
    this.loading = true
    try {
      let params = {
        validOnly: this.validOnly,
      }

      const elements = await API.get('/master/dept', params)
      elements.forEach((element) => {
        element['deptText'] = element['deptCd'] + ' : ' + element['deptName']
        this.items.push(element)
      })
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0242') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
